import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { LocaleInfoIdSchema } from '../locale/locale.types.js';
import { UserInfoIdSchema } from '../user/user.types.js';
import { workoutPlanStatuses, workoutVisibilities } from './workout.constants.js';
// ===== ID SCHEMAS =====
const WorkoutPlanIdSchema = createIdSchema('workoutPlan');
const WorkoutPlanTableSelectSchema = createStrictSchema()({
    id: WorkoutPlanIdSchema,
    status: z.enum(workoutPlanStatuses),
    canonicalName: z.string().nullable(),
    name: z.string().nullable(),
    description: z.string().nullable(),
    system: z.boolean(),
    userId: UserInfoIdSchema.nullable(),
    visibility: z.enum(workoutVisibilities),
    estimatedDurationSeconds: z.number().nullable(),
    notes: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const WorkoutPlanTranslationTableSelectSchema = createStrictSchema()({
    workoutPlanId: WorkoutPlanIdSchema,
    localeId: LocaleInfoIdSchema,
    nameTranslation: z.string(),
    descriptionTranslation: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const WorkoutPlanInfoSchema = WorkoutPlanTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
    name: z.string(),
    description: z.string().nullable(),
});
const WorkoutPlanInfoIdSchema = WorkoutPlanIdSchema;
export { WorkoutPlanInfoIdSchema, WorkoutPlanInfoSchema, WorkoutPlanTableSelectSchema, WorkoutPlanTranslationTableSelectSchema, };
//# sourceMappingURL=workout.types.js.map